import "./../App.css";
import { LinkCardEntry } from "../data/Types";

interface LinkCardProps {
  entry: LinkCardEntry;
}

export default function LinkCard({ entry }: LinkCardProps) {
  const dynamicCardCss = !!entry.linkPath
    ? " hover:opacity-80 active:bg-gray-100"
    : " hover:cursor-default";
  const clickMessage =
    entry.clickMessageOverrideText ?? "Click here to explore their website.";
  return (
    <a
      className={
        "card rounded-lg bg-white drop-shadow-md w-full flex gap-10 smw:gap-4 p-4 2xsw:py-2" +
        dynamicCardCss
      }
      href={entry.linkPath}
    >
      {entry.imgPath && (
        <img
          className="max-w-xs smw:w-1/3 object-contain"
          src={entry.imgPath}
          alt={entry.imgAlt}
        />
      )}
      <div className="w-full h-full">
        {entry.title && (
          <h1 className="text-2xl smw:text-lg 2xsw:text-sm text-center">
            {entry.title}
          </h1>
        )}
        <div className="pt-3 w-full h-full flex flex-col justify-center">
          <p className="text-center text-lg xsw:text-xs">{entry.text ?? ""}</p>
          {entry.linkPath && (
            <p className="pt-3 xsw:text-sm 2xsw:text-xs text-center">
              {clickMessage}
            </p>
          )}
        </div>
      </div>
    </a>
  );
}
